function e(e=""){return`.${e.trim().replace(/([\.:!\/])/g,"\\$1").replace(/ /g,".")}`}export{e as default};
//# sourceMappingURL=classes-to-selector.js.map
